// Toast 停留时间duration
export const duration = 1
export const REQUEST_TOAST_DURATION = 3
export const EMPTY_TEXT = "-"
export const API_PRE_FIX = "/api"
export const OFF_LINE = "重新登录"
export const USER_UNLOGIN = "用户未登陆"
export const ERROR_CODE = "-1"
export const SUCC_CODE = "000000000"
export const DEFAULT_DOC_TITLE = "赋能工具"
export const NEW_TENANTCODE = "100001"
// export const OLD_TENANTCODE = "100000";
export enum RECORD_TYPE {
  // eslint-disable-next-line
  NORMAL,
  // eslint-disable-next-line
  WECHAT,
  // eslint-disable-next-line
  HUIHUI,
  // eslint-disable-next-line
  QYWX,
  // eslint-disable-next-line
  PHONE,
  // eslint-disable-next-line
  SHORTMESSAGE,
  // eslint-disable-next-line
  CONSULTANT,
}

export const CONTACT_SITUATION = [
  { label: "未接触", value: "01" },
  { label: "已接触", value: "02" },
]

export const YES_NO = [
  { label: "是", value: 2 },
  { label: "否", value: 1 },
]

export const UN_REMIND = "-1"

export const ADDNOTICE = [
  { label: "不提醒", value: UN_REMIND },
  { label: "前5分钟", value: 5 },
  { label: "前10分钟", value: 10 },
  { label: "前15分钟", value: 15 },
  { label: "前30分钟", value: 30 },
  { label: "前1小时", value: 60 },
]

export const CUSTOMER_TYPE = [
  { label: "A", value: 1 },
  { label: "B", value: 2 },
  { label: "C", value: 3 },
  { label: "D", value: 4 },
]

/** 浏览器类型 */
export const BROSWER_ENV = {
  /** 企业微信 */
  WXWORK: "wxwork",
  /** 微信 */
  WEIXIN: "weixin",
  /** 浏览器 */
  BROSWER: "broswer",
}

export const COMMUNICATE = {
  // 使用hooks请求的 需要在api中加上前缀
  getRecord: "/v1/communicateRecord/getCommunicateRecordList",
  getWechatRecord: "/v1/communicateRecord/getWechatRecord",
  getHuichatRecord: "/v1/communicateRecord/getHuichatRecord",
  getlastesRecord:
    "/v1/communicateRecord/getCustomerNoCloseLastCommunicateRecord",
  getFinishCodeList: "/v1/communicateRecord/getFinishCodeList",
  getFirstCodeList: "/v1/communicateRecord/getFirstCommunicateResultList",
  addRecord: "/v1/communicateRecord/addCommunicateRecord",
  getCommunicate: "/v1/saas/sys/options",
  getPhone: "/v1/communicateRecord/getTelCommunicationRecord",
  getShortMessage: "/v1/saas/customer/comm/record/selectShortMessageByParam",
  getQywx: "/v1/saas/customer/comm/record/wework/getMessageByParam",
  getConsultant:
    "/v1/saas/customer/comm/record/getCommunicateRecordListByCustomerId",
  getQywxContactType: "/v1/saas/customer/contactByMethodType",
}

export const RECORD_API = {
  [RECORD_TYPE.NORMAL]: COMMUNICATE.getRecord,
  [RECORD_TYPE.WECHAT]: COMMUNICATE.getWechatRecord,
  [RECORD_TYPE.HUIHUI]: COMMUNICATE.getHuichatRecord,
  [RECORD_TYPE.PHONE]: COMMUNICATE.getPhone,
  [RECORD_TYPE.SHORTMESSAGE]: COMMUNICATE.getShortMessage,
  [RECORD_TYPE.QYWX]: COMMUNICATE.getQywx,
  [RECORD_TYPE.CONSULTANT]: COMMUNICATE.getConsultant,
}

export const COMMON = {
  loginApp: "/v1/common/isLogin",
  upload: "/v1/fileSystem/upload",
}
export const CUSTOMER = {
  getCustomerIdByUserId: "/v1/customer/getBindCustomerIdByExternalUserid",
  getCustomerInfoByCustomerId: "/v1/customer/getCustomerInfoByCustomerId",
  getCustomerList: "/v1/customer/getCustomerList",
  bindCustomer: "/v1/customer/bindExternalUseridToCustomer",
  getCustomerBusinessOpportunity:
    "/v1/oppotunity/getOppotunityInfoByCustomerId",
  getCustomerPolicy: "/v1/order/getOrderInfoByCustomerId",
  updateCustomerDetail: "/v1/customer/updateCustomer",
  getCustomerPhoneList: "/v1/customer/getCustomerContactMethodList",
  getCustomerVirtualPhone: "/v1/customer/getVirtualPhone",
  getCustomerScore: "/v1/aiPredict/getCustomerScore",
  getContactDetail: "/v1/customer/getContactDetail",
  getAreasByParentId: "/v1/area/getAreasByParentId",
  updateCustomerStatus: "/v1/customer/updateStatus",
  getCustomerEvent: "/v1/aiPredict/getCustomerEvent",
  getCustomerWilling: "/v1/aiPredict/getCustomerWilling",
  // saveCustomerWilling: "/v1/aiPredict/saveCustomerWilling",
  getAlgorithmCustomerInfo: "/v1/aiPredict/getAlgorithmCustomerInfo",
  getQywxFriendList: "/v1/saas/customer/wechat/friends",
  addCustomer: "/v1/saas/tj/customer",
  queryCurrentCustomer: "/v1/saas/customer/alloc/status",
  getUnderWritingRecord: "/v1/saas/business/insures",
  getClaimRecords: "/v1/saas/claim/records",
  getCommunicateDetail: "/v1/saas/communicate/detail",
  getCurrentUserDetail: "/v1/saas/customer/detail",
  saveUserDetail: "/v1/saas/customer/detail/up",
  saveFamilyDetail: "/v1/saas/customer/family/basic/info",
  getFamilyInfo: "/v1/saas/customer/family/members",
  saveFamilyMember: "/v1/saas/customer/family/member",
  getContactMethods: "/v1/saas/customer/contactMethods",
  getConnectionWayNumber: "/v1/saas/customer/contactMethod",
  getCustomerByIdOrMobile: "/v1/saas/customer/getCustomerByIdOrMobile",
  deleteContactMethod: "/v1/saas/customer/contactMethod/del/apply",
  saveConnectionWayData: "/v1/saas/customer/contactMethod/add",
  updateConnectionWayData: "/v1/saas/customer/contactMethod/update",
  addBusinessOpportunity: "/v1/saas/opportunity",
  saveApplyBindMember: "/v1/saas/customer/saveApplyBindMember",
  getArkOrderByParam: "/v1/saas/business/getArkOrderByParam",
  getMessageTemplate: "/v1/saas/message/template",
  getPreviewTemplate: "/v1/saas/customer/previewTemplate",
  sendTemplate: "/v1/saas/customer/sendTemplate",
  getContactMethodType: "/v1/saas/customer/contactByMethodType",
  getEmployeeInfoListByBusinessCenter:
    "/v1/saas/business/getEmployeeInfoListByBusinessCenter",
  selectOrderInsureNo: "/v1/saas/business/order",
  updateCustomerStarTarget: "/v1/saas/customer/updateCustomerStarTarget",
  getPurchaseCartByMemberId: "/v1/saas/customer/getPurchaseCartByMemberId",
  saveExceptionBinding: "/v1/saas/business/insertArkApplyBindOrder",
  addCrashInsure: "/v1/saas/business/addCrashInsure",
  getIPAddress: "/v1/saas/customer/ip/address",
  getBingdingStatus: "/v1/saas/customer/member/bind/check/apply/status",
  getApplyBindMemberByCustomerId:
    "/v1/saas/customer/comm/record/getApplyBindMemberByCustomerId",
  getCountCustomerNumber: "/v1/task/countCustomerNumber",
  getCustomerTasks: "/v1/task/getCustomerTasks",
  getCustomerJourney: "/v1/flow/getCustomerFlows",
  getAuditPage: "/v1/audit/getPage",
  addAuditTags: "/v1/audit/addTags",
  getUploadUrl: "/v1/audit/getUploadUrl",
  getTag: "/v1/tag/enterprise/getTag",
  getPageEnterpriseTag: "/v1/tag/enterprise/getPageEnterpriseTag",
  saveCustomerLabels: "/v1/tag/enterprise/markTag",
  getFirstCommunicateResultList:
    "/v1/communicateRecord/getFirstCommunicateResultList",
  getEssentialInfo: "/v1/customer/getCustomerInfoByCustomerId",
  getCustomerBaseById: "/v1/customer/getCustomerBaseById",
  getFamilyOverview: "/v1/customer/family/familyOverview",
  getFamilyDetail: "/v1/customer/family/getFamilyDetail",
  newSaveFamilyDetail: "/v1/customer/family/saveFamilyDetail",
  getCustomerFamilyMemberInfo: "/v1/customer/getCustomerFamilyMemberInfo",
  addAndEditMember: "/v1/customer/member",
  getAiTag: "/v1/aiPredict/getCustomerAiTags",
}

export const SOURCE_MATERIAL = {
  getMaterialInfoById:
    "/v1/customerInterface/material/content/getMaterialInfoById",
  getEmployeeWeWorkInfo:
    "/v1/customerInterface/material/content/getEmployeeWeWorkInfo",
}

export const PRODUCT = {
  getCategoryTree: "/v1/product/getCategoryTree",
  getProductList: "/v1/product/getPcProductResult",
  getProductListByKeyWord: "/v1/product/getProductListByKeyWord",
  getProductCollectionList: "/v1/product/getProductCollectionList",
  setSaveProductCollection: "/v1/product/saveProductCollection",
  setCancelProductCollection: "/v1/product/cancellProductCollection",
  saveProductShare: "/v1/product/saveProductShare",
  selectRecommendProductByCustomerId:
    "/v1/product/selectRecommendProductByCustomerId",
}

export const OPPOTUNITY = {
  getCustomerBusinessOpportunity:
    "/v1/oppotunity/getOppotunityInfoByCustomerId",
  getCustomerPolicy: "/v1/order/getOrderInfoByCustomerId",
  updateCustomerDetail: "/v1/customer/updateCustomer",
}

export const QYWX_URL = {
  queryJsSignature: "/v1/qyWechat/queryJsSignature",
  getExternalContact: "/v1/qyWechat/getExternalcontact",
}

export const CUSTOMER_JOURNEY = {
  closeJourney: "/v1/flow/close",
  editJourney: "/v1/flow/change",
}

export const AUDIT = {
  getAuditDetail: "/v1/audit/getDetail",
  getRelationshipInfo: "/v1/audit/getRelationshipInfo",
  getHealthQuestion: "/v1/audit/getHealthPaper",
  getAuditLog: "/v1/audit/getAuditLog",
  addAuditLog: "/v1/audit/addAuditLog",
  getProductInfo: "/v1/audit/getProductInfo",
  getAuditInsureFileItem: "/v1/audit/getAuditInsureFileItem",
  downLoadAuditFiles: "/v1/audit/downloadFiles",
  getAuditSpeed: "/v1/audit/getSpeed",
  getProblemFileInfo: "/v1/audit/getProblemFileInfo",
  getHistoryAudit: "/v1/audit/getHistoryAudit",
}

export const SCRIPT_LIBRARY = {
  queryByParams: "/v1/dialogue/enterprise/queryByParams",
  getEnterpriseChatGroupList:
    "/v1/dialogue/enterprise/chatgroup/getEnterpriseChatGroupList",
  // getEnterpriseChatGroupList:'/saas/enterprise/dialogue/enterprise/chatgroup/getEnterpriseChatGroupList',
  getEnterpriseChatKeywordByPage:
    "/v1/dialogue/enterprise/getEnterpriseChatKeywordByPage",

  addChatContent: "/v1/dialogue/personal/addChatContent",
  addChatGroup: "/v1/dialogue/personal/addChatGroup",
  addDialogue: "/v1/dialogue/personal/addDialogue",
  // batchDeleteById:'/v1/dialogue/personal/batchDeleteById',
  batchDeleteByIdChatGroup: "/v1/dialogue/personal/batchDeleteByIdChatGroup",
  batchDeleteByIdDialogue: "/v1/dialogue/personal/batchDeleteByIdDialogue",
  // checkName:'/v1/dialogue/personal/checkName',
  collectEnterpriseDialogueById:
    "/v1/dialogue/personal/collectEnterpriseDialogueById",
  getPageChatContent: "/v1/dialogue/personal/getPageChatContent",
  getPageChatGroup: "/v1/dialogue/personal/getPageChatGroup",
  updateChatGroup: "/v1/dialogue/personal/updateChatGroup",
  getPageDialogueAll: "/v1/dialogue/personal/getPageDialogueAll",
  addDialogueAndChatContent: "/v1/dialogue/personal/addDialogueAndChatContent",
  updateDialogueAndChatContent:
    "/v1/dialogue/personal/updateDialogueAndChatContent",
  parseLinkArticle: "/v1/dialogue/enterprise/parseLinkArticle",
  queryGoodsByParams: "/v1/dialogue/enterprise/queryGoodsByParams",
  querySourceByParams: "/v1/material/content/queryByParams",
  uploadQywxFile: "/v1/material/content/uploadByUrl",
  getSearchDialogue: "/v1/dialogue/enterprise/ai/searchDialogue",
}

// 素材模块接口
export const MATERIAL: { [key: string]: string } = {
  getMaterialContent: "/v1/material/content/queryByParams", // 查询素材列表
  getChatContents: "/v1/material/content/queryAllChatContent", // 查询素材标签列表
  getSelectAllBusinessChat: "/v1/material/content/selectAllBusinessChat",
  selectShareUrl: "/v1/material/content/selectShareUrl",
  getUserUnionId: "/v1/customerInterface/material/content/getUinonIdByCode", // ^ 根据code查openId
  getUserInfoByCode: "/v1/customerInterface/material/content/getUserInfoByCode", // ^ 查询用户信息
  getWxAppId: "/v1/customerInterface/material/content/getAppid", // 根据环境获取公众号appId
  uploadByFile: "/v1/material/content/uploadByFile",
  sendLookRemind: "/v1/customerInterface/material/content/lookRemind",
  sendLookRemind2: "/v1/customerInterface/material/content/lookRemindV2",
}

export const GROUP_DETAIL = {
  getGroupInfo: "/v1/customer/groupInfo/getPage",
  getTagData: "/v1/customer/groupChatTag/getPage",
  markGroupTag: "/v1/customer/groupChatTag/markTag",
  getStatisticsActive: "/v1/customer/groupChat/statisticsActive",
  getStatisticsAge: "/v1/customer/groupChat/statisticsAge",
  getStatisticsRegion: "/v1/customer/groupChat/statisticsRegion",
  getStatisticsSex: "/v1/customer/groupChat/statisticsSex",
  getGroupMemberPage: "/v1/customer/groupInfo/getGroupMemberPage",
  getGroupChatTag: "/v1/customer/groupChatTag/getTag",
  getGroupSopTasks: "/v1/groupSop/sopTask/selectGroupTaskNodeByParam",
  completeGroupSopTask: "/v1/groupSop/sopTask/updateSopTaskExecuteStatus", // % 后端暂时没写
}

export const NO_ERROR_TOAST_API = [
  PRODUCT.selectRecommendProductByCustomerId,
  MATERIAL.sendLookRemind,
]

export const NO_TOAST_API = [
  COMMON.loginApp,
  QYWX_URL.queryJsSignature,
  CUSTOMER.updateCustomerStatus,
  CUSTOMER.getContactDetail,
  PRODUCT.setSaveProductCollection,
  PRODUCT.setCancelProductCollection,
  PRODUCT.saveProductShare,
  PRODUCT.getCategoryTree,
  CUSTOMER.getCustomerBusinessOpportunity,
  CUSTOMER.getQywxFriendList,
  COMMUNICATE.getCommunicate,
  CUSTOMER.getAreasByParentId,
  CUSTOMER.getUnderWritingRecord,
  CUSTOMER.getClaimRecords,
  CUSTOMER.queryCurrentCustomer,
  CUSTOMER.getConnectionWayNumber,
  CUSTOMER.getArkOrderByParam,
  CUSTOMER.sendTemplate,
  CUSTOMER.addCrashInsure,
  CUSTOMER.updateCustomerStarTarget,
  CUSTOMER.getCountCustomerNumber,
  CUSTOMER.getCustomerTasks,
  CUSTOMER.getAuditPage,
  AUDIT.getAuditDetail,
  AUDIT.getRelationshipInfo,
  AUDIT.getAuditLog,
  AUDIT.getHistoryAudit,
  AUDIT.getAuditDetail,
  AUDIT.getAuditSpeed,
  SCRIPT_LIBRARY.getEnterpriseChatKeywordByPage,
  SCRIPT_LIBRARY.queryByParams,
  SCRIPT_LIBRARY.getPageChatGroup,
  SCRIPT_LIBRARY.getPageDialogueAll,
  CUSTOMER.getTag,
  CUSTOMER.getPageEnterpriseTag,
  MATERIAL.getMaterialContent,
  SCRIPT_LIBRARY.queryGoodsByParams,
  SCRIPT_LIBRARY.uploadQywxFile,
  PRODUCT.selectRecommendProductByCustomerId,
  MATERIAL.uploadByFile,
  GROUP_DETAIL.getGroupInfo,
  GROUP_DETAIL.getTagData,
  GROUP_DETAIL.getGroupMemberPage,
  SCRIPT_LIBRARY.getSearchDialogue,
  GROUP_DETAIL.getGroupChatTag,
  GROUP_DETAIL.getGroupSopTasks,
  MATERIAL.getUserUnionId,
  MATERIAL.sendLookRemind,
  SOURCE_MATERIAL.getEmployeeWeWorkInfo,
]

// 微信沟通记录的消息枚举
export const MESSAGETYPE: any = {
  VmaTextElem: 1, // 文本
  VmaSoundElem: 2, //语音
  VmaImageElem: 3, //图片
  VmaVideoElem: 4, //视频
  VmaFileElem: 5, //文件
  VmaSystemElem: 6, //系统消息
  WxBusinessCardElem: 7, //名片
  WxLocationElem: 8, //定位
  WxTransferElem: 9, //
  WxRedPacketElem: 10, //
  WxShareLocationElem: 11, //
  VmaImgtxtlinkElem: 12, //
  text: 1,
  link: 13,
  weapp: 1,
  card: 1,
  location: 1,
  redpacket: 1,
  info: 1,
  calendar: 1,
  todo: 1,
  collect: 1,
  file: 5,
  image: 3,
  voice: 2,
  video: 4,
  emotion: 3,
  meeting_voice_call: 14,
}
